document.addEventListener('magiczoomplus:beforeinit', function(){
        if (typeof window['mzdone']=='undefined' && typeof mtOnDomReady != 'undefined') {
            if (document.querySelector('#magic-zoom-plus-block')) {
              document.querySelector('#magic-zoom-plus-block').setAttribute('id','magic-zoom-plus-block-')
            }
            mtOnDomReady(function() {
              setTimeout(function(){
                if (document.querySelector('#magic-zoom-plus-block-')) {
                  document.querySelector('#magic-zoom-plus-block-').setAttribute('id','magic-zoom-plus-block')
                }
                initmzptheme();
              },100);
            });
            window['mzdone'] = true;
        }
})